import { useToast } from "@wayflyer/flyui";
import { ConnectionSchemas } from "api-types";
import { useEffect } from "react";
import { useIntl } from "react-intl";
import { useAnalyticsContext } from "shared-utils";

import { CompleteConnectionModal } from "../../components/complete-connection-modal/complete-connection-modal";
import { completeConnectionTransformer } from "../transformers";
import { dataSourceSlugToName } from "../utils";

import { useOAuthError } from "./useOAuthError";

type UseCompleteConnectionModalProps = {
  completeConnection?: ConnectionSchemas.CompleteConnectionPropsSchema;
  errorHandler: any;
};

export const useCompleteConnectionModal = ({ completeConnection, errorHandler }: UseCompleteConnectionModalProps) => {
  /**
   * Reads oAuthError from completeConnection props and sets the error toast props
   */
  useOAuthError(completeConnection, errorHandler);
  const intl = useIntl();
  const analyticsContext = useAnalyticsContext();
  const toaster = useToast();
  const transformedCompleteConnection = completeConnectionTransformer(
    intl,
    completeConnection,
    analyticsContext,
    toaster
  );

  /**
   * Prepare the connection success toast props based on the query param
   */
  useEffect(() => {
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);

    if (urlParams.has("connectionSucceed")) {
      const dataSourceName = dataSourceSlugToName(urlParams.get("connectionSucceed"));

      toaster.positive(
        intl.formatMessage(
          {
            id: "shared-ui: reconnecting platform - success",
            defaultMessage: "{dataSourceName} successfully connected",
          },
          { dataSourceName }
        )
      );
    }
    // We can't add toaster to the deps as it would re-render continuously
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (transformedCompleteConnection == null) {
    return <></>;
  } else {
    return <CompleteConnectionModal {...transformedCompleteConnection} />;
  }
};
